import {SET_REVIEW_EMAILS} from '../_CONSTANTS';

export const setReviewEmails = (emails) => {
  return {
    type: SET_REVIEW_EMAILS,
    payload: emails
  }
}

